import { Component, input } from '@angular/core';
import { fadeInFadeOut } from '../animations';
import { InlineLoaderComponent } from './inline-loader/inline-loader.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  animations: [fadeInFadeOut],
  imports: [InlineLoaderComponent, TranslatePipe],
})
export class LoaderComponent {
  readonly isDisplay = input<boolean>(true);
}
